import React, { useState } from 'react';
import { FaUmbrellaBeach, FaCalendarDay, FaStar, FaUserTie } from 'react-icons/fa';

const CalendarEventBadge = ({ event, onClick, isInterview = false }) => {
  const [hovered, setHovered] = useState(false);

  if (isInterview) {
    const handleClick = (e) => { e.stopPropagation(); onClick?.(event); };
    const formatTime = (t) => {
      if (!t) return '';
      const [hh, mm] = t.split(':').map(Number);
      const ampm = hh >= 12 ? 'PM' : 'AM';
      const h12 = hh === 0 ? 12 : hh > 12 ? hh - 12 : hh;
      return mm === 0 ? `${h12} ${ampm}` : `${h12}:${String(mm).padStart(2, '0')} ${ampm}`;
    };

    return (
      <div
        className="ic-badge ic-badge-interview"
        onClick={handleClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <FaUserTie className="ic-badge-icon" />
        <span className="ic-badge-text">{event.title || event.companyName || 'Interview'}</span>

        {hovered && (
          <div className="ic-tip">
            <div className="ic-tip-title">{event.title || event.companyName || 'Interview'}</div>
            {event.startTime && (
              <div className="ic-tip-dates">
                {formatTime(event.startTime)}{event.endTime ? ` – ${formatTime(event.endTime)}` : ''}
              </div>
            )}
            <div className="ic-tip-type ic-tip-orange">
              {event.roundType || 'Interview'}
            </div>
            {event.mode && <div className="ic-tip-dates">{event.mode}</div>}
          </div>
        )}
      </div>
    );
  }

  const isHoliday = event.type === 'HOLIDAY';
  const isOverride = event.type === 'EVENT' && event.isWorkingDay === true;

  let cls = 'ic-badge ic-badge-event';
  let Icon = FaCalendarDay;
  if (isHoliday) { cls = 'ic-badge ic-badge-holiday'; Icon = FaUmbrellaBeach; }
  else if (isOverride) { cls = 'ic-badge ic-badge-override'; Icon = FaStar; }

  const fmt = (d) => new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', timeZone: 'Asia/Kolkata' });

  const handleClick = (e) => { e.stopPropagation(); onClick?.(event); };

  return (
    <div
      className={cls}
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Icon className="ic-badge-icon" />
      <span className="ic-badge-text">{event.title}</span>

      {hovered && (
        <div className="ic-tip">
          <div className="ic-tip-title">{event.title}</div>
          <div className="ic-tip-dates">
            {fmt(event.startDate)}
            {event.endDate !== event.startDate ? ` – ${fmt(event.endDate)}` : ''}
          </div>
          <div className={`ic-tip-type ${isHoliday ? 'ic-tip-red' : 'ic-tip-blue'}`}>
            {isHoliday ? 'Holiday' : isOverride ? 'Working Override' : 'Event'}
          </div>
        </div>
      )}
    </div>
  );
};

export default CalendarEventBadge;
